// store/thunks/auth/sendRecoveryTwoFactorThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { VerificationDTO } from '@/types/dtos.types';

export const sendRecoveryTwoFactorThunk = createAdminAsyncThunk<
  VerificationDTO,
  { recoveryToken: string },
  { rejectValue: { message: string } }
>(
  'auth/sendRecoveryTwoFactorThunk',
  async({ recoveryToken }, { extra: { authService }, rejectWithValue }) => {
    try {
      return await authService.sendRecoveryTwoFactor({ recoveryToken });
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send reset password email';
      return rejectWithValue({ message });
    }
  }
);
